export default "__VITE_ASSET__DBG2UqCa__"